import Dialog from '@/pages/pcp/components/components/Dialog';
import Step from '@/pages/pcp/components/components/Step';
import { useContext, useMemo } from 'react';

import settings from '@/constants/pcp/constants';
import { PCPStepContext } from '@/pages/pcp/components/components/StepContextWrapper';
import useTracking from '@/pages/pcp/hooks/useTracking';
import { PCPDataContext } from '@/pages/pcp/PCPortal';

export default function NursePreConsultForm() {
  const { modalOpen, setModalOpen, url, isLink, ga4Events } = useContext(PCPStepContext);
  const { userData, fetchUserData } = useContext(PCPDataContext);

  const { sendGa4Events } = useTracking();

  const handleButtonClick = (mouseEvent: React.MouseEvent<HTMLButtonElement>) => {
    sendGa4Events(ga4Events?.buttonClickEvents);

    if (!isLink) {
      if (url && mouseEvent.ctrlKey) {
        window.open(url, '_blank');
        return;
      }
      setModalOpen(true);
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    fetchUserData({ updateLoadingState: false });
  };

  const generatePreconsultFormIframeUrl = useMemo(() => {
    const patientEmail = userData?.prefillFormData.email;

    return `${settings.preconsultFormUrl}?enable=embed${patientEmail ? `&email=${encodeURIComponent(patientEmail)}` : ''}`;
  }, [userData?.prefillFormData.email]);

  return (
    <>
      <Step onButtonClick={handleButtonClick} divider />

      <Dialog open={modalOpen} onCloseButtonClick={handleModalClose}>
        <iframe src={generatePreconsultFormIframeUrl} style={{ minHeight: '65vh' }}></iframe>
      </Dialog>
    </>
  );
}
